module.exports = __webpack_public_path__ + "img/box.033d98f9.png";